import { type ProjectionWatermarksResponse, type RoiRepository } from '../../ports';

export interface ProjectionStatusRequest {
  sampleId: string;
  creatorId: string;
  /** Narrows the read to these findings; omit for the whole sample. */
  findingIds?: string[];
}

/**
 * Reads how far the mosaic projection has got for one analyst's view of one sample, as
 * `findingId -> projectedVersion` plus whether a backfill has covered the pair.
 *
 * The caller compares those versions against the ones it expects - from its own save, or
 * from the source-of-record stats - and is behind when one it expects is missing or
 * lower. Deciding that is not this use case's job: what counts as expected differs per
 * caller, and only the caller knows whether it just wrote something.
 */
export class GetProjectionStatusUseCase {
  constructor(private readonly rois: RoiRepository) {}

  public execute(request: Readonly<ProjectionStatusRequest>): Promise<ProjectionWatermarksResponse> {
    return this.rois.getProjectionWatermarks(request);
  }
}
